import { ApolloProvider, } from "@apollo/client/react";
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Pages/App';

import { setContext } from '@apollo/client/link/context';
import { BrowserRouter } from 'react-router-dom';
import { APPCONFIG } from './app.config';
import { Provider } from 'react-redux';
import { store } from './store';
import { Buffer } from 'buffer';

// import 'dotenv/config'
window.Buffer = Buffer;

// Crea un `fetch` personalizado con timeout
const customFetch = (uri, options) => {
  const timeout = 900000; // 90 segundos (ajustable)
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Request Timeout')), timeout);

    fetch(uri, options).
      then(resolve).
      catch(reject).
      finally(() => clearTimeout(timer)); // Limpia el temporizador al finalizar
  });
};

const httpLink = new HttpLink({ uri: APPCONFIG.SITE.WEBAPI, fetch: customFetch });

const authLink = setContext((request, { headers }) => {

  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </Provider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals